export var EventSeriesOption = {
    THIS_EVENT: 'this_event',
    THIS_AND_FOLLOWING_EVENTS: 'this_and_following_events',
    ALL_EVENTS: 'all_events',
};
